import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ShipmentCreate,
    ShipmentDto,
    ShipmentRead,
    ShipmentSearchParams,
} from '../../entities/shipment.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ShipmentMetadataMap } from './shipment.mapping-profile';

@Injectable()
export class ShipmentMapper extends AbstractEntityMapper<
    ShipmentRead,
    ShipmentCreate,
    ShipmentDto,
    ShipmentSearchParams
> {
    constructor() {
        super(ShipmentDto, PlatformWmsMapper, ShipmentMetadataMap.symbols);
    }
}
